import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=3a6d9b7c"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports